export default "/shell-small.51ef6a0050e607fccdc4f07b2649741d.svg";